import { useSyncExternalStore } from 'react';
import { getQueuedMutationCount, subscribeQueueChanges } from '@app/lib/offlineQueue';

export interface SyncState {
  flushing: boolean;
  lastRunAt: string | null;
  lastResult: string;
}

function useQueuedCount(): number {
  return useSyncExternalStore(subscribeQueueChanges, getQueuedMutationCount, () => 0);
}

export function SyncDock({
  online,
  syncState
}: {
  online: boolean;
  syncState: SyncState;
}) {
  const queuedCount = useQueuedCount();

  return (
    <div className="sync-dock">
      <div className="sync-pill" aria-label={online ? 'Online' : 'Offline'}>
        <span className={`sync-dot ${online ? 'sync-dot--online' : 'sync-dot--offline'}`} />
        <span>{online ? 'Online' : 'Offline'}</span>
      </div>
      <div className="sync-pill" aria-label={`${queuedCount} queued writes`}>
        <span>{queuedCount} queued</span>
      </div>
      <div className="sync-pill" aria-label={syncState.lastResult}>
        <span>{syncState.flushing ? 'Syncing…' : syncState.lastRunAt ? new Date(syncState.lastRunAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : 'Ready'}</span>
      </div>
    </div>
  );
}
